var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStrategicRoadmapIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5L15.75 11.25L13.5 9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4716 1.65856L1.66046 11.4697C1.36757 11.7626 1.36757 12.2374 1.66046 12.5303L11.4749 22.3448C11.7678 22.6376 12.2427 22.6376 12.5355 22.3448L22.3467 12.5336C22.6395 12.2408 22.6395 11.7659 22.3467 11.473L12.5322 1.65856C12.2393 1.36567 11.7645 1.36567 11.4716 1.65856Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25003 14.25V13.5C8.24879 13.2042 8.30614 12.9111 8.41877 12.6375C8.53141 12.364 8.69709 12.1154 8.90627 11.9063C9.11545 11.6971 9.36398 11.5314 9.63752 11.4188C9.91107 11.3061 10.2042 11.2488 10.5 11.25H15.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStrategicRoadmapIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/strategicRoadmapIcon.eaa99a7128280be9f3dd1e6717b2eb86.svg";